import "./App.css";

function App() {
  return (
    <div className="app-shell">
      <header className="hero">
        <img 
          src="/uploads/hero.jpg" 
          alt="Uscybint - Your trusted source for cybersecurity intelligence" 
          className="hero-image" 
        />
        <p className="eyebrow">Uscybint · Empowering Your Cybersecurity Journey</p>
        <h1>Stay Ahead of Cyber Threats</h1>
        <p className="lede">
          Discover essential resources and insights to navigate the complex world of cybersecurity. 
          Equip yourself with the knowledge to protect your digital assets effectively.
        </p>
        <div className="cta-row">
          <a href="/resources" target="_self">
            Explore Resources
          </a>
          <a href="/about" target="_self" className="secondary">
            Learn More About Us
          </a>
        </div>
      </header>

      <section className="cards">
        <article>
          <h2>Comprehensive Insights</h2>
          <p>
            Access in-depth articles and reports that cover the latest trends and threats in cybersecurity.
          </p>
        </article>
        <article>
          <h2>Expert Guidance</h2>
          <p>
            Benefit from expert advice and best practices to enhance your cybersecurity posture.
          </p>
        </article>
        <article>
          <h2>Community Support</h2>
          <p>
            Join a community of like-minded individuals and professionals dedicated to sharing knowledge and resources.
          </p>
        </article>
      </section>
    </div>
  );
}

export default App;